import React from "react";
import { Search } from "lucide-react";

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  /**
   * Tailwind classes for the outer wrapper. Defaults to `max-w-60` to keep
   * the historic cap; pass an empty string (or e.g. `"max-w-none"`) to let
   * the input fill its parent (useful inside grid cells).
   */
  wrapperClassName?: string;
};

const SearchInput: React.FC<SearchInputProps> = ({
  className,
  wrapperClassName,
  ...props
}) => {
  return (
    <div
      className={`flex items-center border rounded-md p-2 text-sm text-gray-500 w-full ${
        wrapperClassName ?? "max-w-60"
      }`}
    >
      <Search className="w-4 h-4 text-gray-400 mr-2" />
      <input
        type="text"
        className={`focus:outline-none w-full ${className}`}
        {...props}
      />
    </div>
  );
};

export default SearchInput;
